import { css, cx } from "@emotion/css";
import { Popper } from "src/components/Default/LekUI/Popper";
import { LongText } from "src/components/Default/LongText";
import { ExamSimpleStatistics } from "src/components/Statistics/exam/ExamSimpleStatistic";

interface ExamStats {
	correctAnswersPercent: number;
	wrongAnswersPercent: number;
	cancelledQuestionsPercent: number;
	skippedQuestionsPercent: number;
	totalQuestions: number;
	correctAnswers: number;
	wrongAnswers: number;
	skippedQuestions: number;
	cancelledQuestions: number;
	score: number;
}

interface CircleChartProps {
	onClick: (e: React.MouseEvent) => void;
	stats: ExamStats;
	title?: string;
	className?: string;
}

export const CircleChart = ({ onClick, stats, title, className }: CircleChartProps) => {
	const {
		correctAnswersPercent,
		wrongAnswersPercent,
		cancelledQuestionsPercent,
		skippedQuestionsPercent,
	} = stats;

	const correctEnd = correctAnswersPercent;
	const wrongEnd = correctAnswersPercent + wrongAnswersPercent;
	const cancelledEnd = wrongEnd + cancelledQuestionsPercent;
	const skippedEnd = cancelledEnd + skippedQuestionsPercent;

	return (
		<div className={cx(className, "circle-chart")}>
			{title && (
				<LongText className="size-16-light text-ellipsis-1 first-letter-upper">
					{title}
				</LongText>
			)}
			<div
				onClick={onClick}
				className={cx(
					"pie-chart cursor-pointer",
					css`
            background-image: ${
							stats.totalQuestions === 0
								? "conic-gradient(var(--bgFill2) 0%, var(--bgFill2) 100%)"
								: `conic-gradient(
              var(--green) 0%,
              var(--green) ${correctEnd}%,
              var(--red) ${correctEnd}%,
              var(--red) ${wrongEnd}%,
              var(--darkPink) ${wrongEnd}%,
              var(--darkPink) ${cancelledEnd}%,
              var(--primaryBlue) ${cancelledEnd}%,
              var(--primaryBlue) ${skippedEnd}%
            )`
						};
          `,
				)}
			>
				<span className="size-18">{stats.totalQuestions}</span>
			</div>
		</div>
	);
};

interface CircleChartWithStatsProps {
	stats: ExamStats;
	title: string;
	className?: string;
}

export const CircleChartWithStats = ({ stats, title }: CircleChartWithStatsProps) => {
	return (
		<Popper
			className={cx(
				"p-12",
				css`
          z-index: 99999999;
        `,
			)}
			renderTrigger={({ setAnchor }: { setAnchor: (e: React.MouseEvent) => void }) => {
				return <CircleChart title={title} onClick={setAnchor} stats={stats} />;
			}}
		>
			{() => (
				<div className="flex flex-col">
					<h3 className="size-18 first-letter-upper m-0">{title}</h3>
					<div className="divider--horizontal bg-border mt-12 mb-16" />
					<ExamSimpleStatistics
						className={css`
              min-width: 300px;
            `}
						stats={stats}
					/>
				</div>
			)}
		</Popper>
	);
};
